import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * A component to display informational text within a form.
 * This is a non-input component that just displays text and a divider.
 * 
 * @param {string} label - The text to display.
 * @param {object} otherProps - Other props to pass to the Box component.
 * @returns {JSX.Element}
 */
const FormInfoField = ({ label, ...otherProps }) => {
  return (
    <Box sx={{ my: 2, width: '100%' }} {...otherProps}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        {label}
      </Typography>
      <Divider />
    </Box>
  );
};

FormInfoField.propTypes = {
  label: PropTypes.string.isRequired,
};

export default FormInfoField;